import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { Role, isRole } from '@optical/rbac';

import { AuthStore } from '../state/auth';

export const roleCanActivateFn: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const requiredRole = route.data['role'];

  if (!isRole(requiredRole)) {
    throw new Error(`Route protected by invalid role: ${requiredRole}`);
  }

  return redirectIfUnauthorized(requiredRole);
};

/**
 * Redirects the user to the home page if they do not have the required role
 *
 * @param requiredRole Required role to access the route
 * @returns True if the user has the required role, false otherwise
 */
function redirectIfUnauthorized(requiredRole: Role): boolean {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const hasRole = authStore.hasRole(requiredRole)();

  if (!hasRole) {
    router.navigate(['/']);
  }

  return hasRole;
}
